// Utility para combinar clases Tailwind con merge inteligente (resuelve
// conflictos: `cn("px-2", "px-4")` → `"px-4"`).
//
// Patrón estándar de shadcn/ui pero sin la CLI — los componentes UI viven en
// `components/ui/` escritos a mano para evitar deps de Radix en el MVP.

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
